import { ActionTypesEnum } from './action-type.enum';

export class Action {
   type: ActionTypesEnum;
   callerId: string;
   ts: number;
   content: any = null;


   constructor(type: ActionTypesEnum, callerId?: string, content?: any) {
      this.type = type;
      this.callerId = callerId;
      this.ts = new Date().getTime();
      if (content) {
         this.content = content;
      }

   }
}